import styled, { css } from "styled-components";
import { ButtonState } from ".";

const shared = css<{ state: ButtonState }>`
  cursor: pointer;
  border: none;
  color: ${({ theme }) => theme.deprecatedColors.gray.four};
  background-color: transparent;

  &:disabled {
    color: ${({ theme }) => theme.deprecatedColors.gray.eight};
    cursor: not-allowed;
  }
`;

export const button = styled.button<{ state: ButtonState }>`
  ${shared}
`;

export const a = styled.a<{ state: ButtonState; href: string }>`
  ${shared}
`;
